'use client';
import { useEffect, useState } from 'react';

import type { Data } from '@strapi/types';

import { useAppContext } from '@/modules/app-context/use-app-context';

import { useProjectListInit } from './use-project-list-init';
import { useTranslations } from '@power-core/toolkit';

export const useProjectListParams = ({ title }: Pick<Data.Entity<'api::project.project'>, 'title'>) => {
	const [sort, setSort] = useState<string | undefined>('lastUpdatedDate:desc');
	const { projects, isPending } = useProjectListInit(title, sort);
	const { setProject, project, setSearchStatusId, setUnselectedProjectMessage } = useAppContext();
	const [openIndex, setOpenIndex] = useState<string>('');
	const t = useTranslations();

	useEffect(() => {
		if (!projects?.length || !projects[0].documentId) return;

		setProject(projects[0]);
		setOpenIndex(projects[0].documentId);
	}, [projects, projects?.length]);

	const handleToggle = (index?: string | null) => {
		if (!index) return;

		setOpenIndex((prevIndex) => (prevIndex === index ? '' : index));
		setSearchStatusId('');

		if (project?.documentId === index) {
			setProject(null);
			setOpenIndex('');
			setUnselectedProjectMessage(t('T_SELECT_PROJECT'));
			return;
		}

		if (index === 'sharedDocuments') {
			setProject(null);
			setUnselectedProjectMessage(t('T_OPEN_SHARED_DOCUMENTS'));
			return;
		}

		if (projects?.length) setProject(projects.find((project) => project.documentId === index) ?? null);
	};

	return {
		projects,
		isPending,
		openIndex,
		setOpen: setOpenIndex,
		handleToggle,
		setSort,
	};
};
